/* Threads on Design - moved here from the snippets listed below on 18 OCT 2026 (TEST 6) so phones keep it between pages.
   Edit it here; the notes stay in that file. */

/* ---- snippets/tod-topnext.liquid ---- */
try {
  (function () {
    'use strict';

    var box = null;

    function realNav()  { return document.querySelector('.tod-stepnav'); }
    function realNext() { var n = realNav(); return n ? n.querySelector('.tod-next') : null; }
    function realBack() { var n = realNav(); return n ? n.querySelector('.tod-back') : null; }
    function realNote() { var n = realNav(); return n ? n.querySelector('.sn-note') : null; }

    function visible(el) {
      return !!(el && el.offsetParent !== null);
    }

    function build() {
      if (box && box.isConnected) { return box; }
      box = document.createElement('div');
      box.className = 'tod-topnext';
      box.innerHTML =
        '<div class="ttn-row">' +
          '<button type="button" class="ttn-back">Back</button>' +
          '<button type="button" class="ttn-next">Next</button>' +
        '</div>' +
        '<p class="ttn-note"></p>';
      box.querySelector('.ttn-next').addEventListener('click', function (e) {
        e.preventDefault();
        var b = realNext();
        if (b) { b.click(); }
        schedule();
      });
      box.querySelector('.ttn-back').addEventListener('click', function (e) {
        e.preventDefault();
        var b = realBack();
        if (b) { b.click(); }
        schedule();
      });
      return box;
    }

    /* Where the button belongs on the step we are currently on.
       Returns null on any step that should not have one. */
    function anchor() {
      var c = document.body.classList;

      if (c.contains('tod-step-1')) {
        /* under the last lettering card that is actually on screen */
        var apron = document.getElementById('ed-apron');
        var cape  = document.getElementById('ed-cape');
        if (visible(apron)) { return apron; }
        if (visible(cape))  { return cape; }
        return null;
      }

      if (c.contains('tod-step-2')) {
        var card = document.querySelector('.stage .stage-card');
        if (visible(card)) { return card; }
        var stage = document.querySelector('.stage');
        return visible(stage) ? stage : null;
      }

      return null;
    }

    function sync() {
      if (!box || !box.isConnected) { return; }
      var n = realNext();
      var bk = realBack();
      var note = realNote();

      var tn = box.querySelector('.ttn-next');
      var tb = box.querySelector('.ttn-back');
      var tnote = box.querySelector('.ttn-note');

      if (n) {
        var label = (n.textContent || '').trim() || 'Next';
        if (tn.textContent !== label) { tn.textContent = label; }
        tn.disabled = !!n.disabled;
      }

      /* Back only where the real bar shows one — never on step 1 */
      var showBack = !!bk && !document.body.classList.contains('tod-step-1');
      tb.style.display = showBack ? '' : 'none';

      var txt = note ? (note.textContent || '').trim() : '';
      if (tnote.textContent !== txt) { tnote.textContent = txt; }
      tnote.style.display = txt ? '' : 'none';
    }

    function place() {
      if (!realNav()) { return; }

      var a = anchor();
      if (!a) {
        if (box && box.parentNode) { box.parentNode.removeChild(box); }
        return;
      }

      var el = build();
      if (a.nextSibling !== el) {
        a.parentNode.insertBefore(el, a.nextSibling);
      }
      sync();
    }

    /* No MutationObserver — a short burst of bounded passes off real events.
       Three passes, not one: when you flip the "apron is different" switch the
       apron card takes a moment to show, and a single 160ms pass can measure
       it while it is still hidden and anchor the button too high. */
    var timers = [];
    function schedule() {
      for (var t = 0; t < timers.length; t++) { clearTimeout(timers[t]); }
      timers = [];
      var at = [160, 550, 1200];
      for (var k = 0; k < at.length; k++) {
        timers.push(setTimeout(function () {
          try { place(); } catch (e) {}
        }, at[k]));
      }
    }

    document.addEventListener('click', schedule, true);
    document.addEventListener('input', schedule, true);
    document.addEventListener('change', schedule, true);
    window.addEventListener('resize', schedule);
    window.addEventListener('load', schedule);
    if (document.readyState !== 'loading') {
      schedule();
    } else {
      document.addEventListener('DOMContentLoaded', schedule);
    }

    for (var i = 1; i <= 12; i++) {
      setTimeout(function () { try { place(); } catch (e) {} }, i * 700);
    }
  })();
} catch (e) { setTimeout(function () { throw e; }); }

/* ---- snippets/tod-track.liquid ---- */
try {
  (function () {
    'use strict';

    var SENT = {};
    var PENDING = [];
    var BUNDLE = (location.pathname || '').replace(/^\/+|\/+$/g, '') || 'home';

    function flush() {
      if (typeof window.fbq !== 'function') { return false; }
      while (PENDING.length) {
        var e = PENDING.shift();
        try { window.fbq('trackCustom', e[0], e[1]); } catch (err) {}
      }
      return true;
    }

    function fire(name, extra) {
      if (SENT[name]) { return; }
      SENT[name] = true;

      var params = { bundle: BUNDLE };
      if (extra) { for (var k in extra) { params[k] = extra[k]; } }

      PENDING.push([name, params]);
      flush();

      /* also announce it to Shopify, so a pixel added later can subscribe */
      try {
        if (window.Shopify && window.Shopify.analytics &&
            typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish(name, params);
        }
      } catch (err) {}
    }

    function typedName() {
      var els = document.querySelectorAll('#ed-cape input.ltext, #ed-apron input.ltext');
      for (var i = 0; i < els.length; i++) {
        var v = (els[i].value || '').replace(/\s+/g, '');
        if (v.length >= 2) { return true; }
      }
      return false;
    }

    function pass() {
      /* only on a page that actually has the designer on it */
      if (!document.querySelector('.tod-stepnav')) { return; }

      fire('TOD_DesignerView');

      if (typedName()) { fire('TOD_NameTyped'); }

      var c = document.body.classList;
      if (c.contains('tod-step-2')) { fire('TOD_Step2', { step: 2 }); }
      if (c.contains('tod-step-3')) { fire('TOD_Step3', { step: 3 }); }

      flush();
    }

    /* No MutationObserver — a short burst of bounded passes off real events,
       plus a longer run of timers to catch the pixel and the designer loading
       late.

       Three passes per event, not one: tapping Next does not change the step
       straight away, so a single 200ms pass measures the page while it is
       still on the old step and the step event is never sent. That exact bug
       silently produced zero step data the first time this was written. */
    var timers = [];
    function schedule() {
      for (var j = 0; j < timers.length; j++) { clearTimeout(timers[j]); }
      timers = [];
      var at = [200, 700, 1500];
      for (var k = 0; k < at.length; k++) {
        timers.push(setTimeout(function () { try { pass(); } catch (e) {} }, at[k]));
      }
    }

    document.addEventListener('click', schedule, true);
    document.addEventListener('input', schedule, true);
    document.addEventListener('change', schedule, true);
    window.addEventListener('load', schedule);
    if (document.readyState !== 'loading') { schedule(); }
    else { document.addEventListener('DOMContentLoaded', schedule); }

    for (var i = 1; i <= 12; i++) {
      setTimeout(function () { try { pass(); } catch (e) {} }, i * 900);
    }
  })();
} catch (e) { setTimeout(function () { throw e; }); }

/* ---- snippets/tod-hero.liquid ---- */
try {
(function(){
  'use strict';
  var IMG='https://cdn.shopify.com/s/files/1/0977/1148/9394/files/tod-gal-shine-table_1.jpg?v=1788557456&width=1400';
  var STEPS=[['1','Type your salon name'],['2','Mockup within 30 minutes'],['3','Stitched and shipped — free on orders $99+']];

  function build(){
    var shead=document.querySelector('.tod .shead .wrap');
    if(!shead||document.getElementById('tod-hero')) return;
    var box=document.createElement('div'); box.id='tod-hero';
    var fig=document.createElement('figure'); fig.className='th-shot';
    var im=document.createElement('img');
    im.src=IMG;
    im.alt='A finished salon order folded on the table, every piece embroidered with the same salon name in gold script';
    im.loading='eager'; im.width=1400; im.height=1050;
    fig.appendChild(im); box.appendChild(fig);
    var ol=document.createElement('ol'); ol.className='th-steps';
    STEPS.forEach(function(s){
      var li=document.createElement('li');
      var b=document.createElement('b'); b.textContent=s[0];
      var sp=document.createElement('span'); sp.textContent=s[1];
      li.appendChild(b); li.appendChild(sp); ol.appendChild(li);
    });
    box.appendChild(ol);
    shead.appendChild(box);
    document.body.classList.add('tod-hero-on');
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',build);}else{build();}
  setTimeout(build,600); setTimeout(build,1800);
})();
} catch (e) { setTimeout(function () { throw e; }); }

/* ---- snippets/tod-switchfix.liquid ---- */
try {
(function () {
  'use strict';
  /* 3. The review count. */
  var COUNT = 7;
  var FIND = /\b\d+\s*reviews? on Facebook\b/gi;
  var WANT = COUNT + (COUNT === 1 ? ' review' : ' reviews') + ' on Facebook';

  function reviews() {
    if (!document.body) { return; }
    var walk = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
    var node, todo = [];
    while ((node = walk.nextNode())) {
      var p = node.parentNode;
      if (!p || p.nodeName === 'SCRIPT' || p.nodeName === 'STYLE') { continue; }
      var v = node.nodeValue;
      if (!v || v.indexOf('review') === -1) { continue; }
      FIND.lastIndex = 0;
      var nv = v.replace(FIND, WANT);
      if (nv !== v) { todo.push([node, nv]); }
    }
    for (var i = 0; i < todo.length; i++) { todo[i][0].nodeValue = todo[i][1]; }
  }

  function pass() { try { reviews(); } catch (e) {} }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pass);
  } else {
    pass();
  }
  setTimeout(pass, 300);
  setTimeout(pass, 1200);
  setTimeout(pass, 2800);
  window.addEventListener('load', function () { setTimeout(pass, 100); });
})();
} catch (e) { setTimeout(function () { throw e; }); }

/* ---- snippets/tod-mobile2.liquid ---- */
try {
(function () {
  'use strict';
  if (!window.matchMedia || !matchMedia('(max-width: 767px)').matches) { return; }

  /* checked on every pass: the set designer draws its inputs after load.
     #tod-pick is the set tiles on the Salon sets page - same first-screen rule. */
  function designer() { return !!document.querySelector('#cb-name, .tod input.ltext, #tod-pick'); }

  /* 1. Chat button */
  var CHAT = '.activator-nudge{left:auto!important;right:12px!important;'
    + 'bottom:calc(84px + env(safe-area-inset-bottom,0px))!important;transition:opacity .25s,transform .25s}'
    + '.activator{font-size:0!important;padding:0!important;width:46px!important;height:46px!important;'
    + 'min-width:46px!important;border-radius:50%!important;display:flex!important;align-items:center!important;'
    + 'justify-content:center!important;box-shadow:0 6px 18px rgba(15,24,40,.35)!important}'
    + '.activator__icon,.activator__icon svg{width:20px!important;height:20px!important}'
    + ':host([data-tod-early]) .activator-nudge{opacity:0!important;pointer-events:none!important;transform:translateY(12px)}';

  function chat() {
    var host = document.querySelector('shopify-chat');
    if (!host || !host.shadowRoot) { return false; }
    if (!host.shadowRoot.getElementById('tod-chat-css')) {
      var st = document.createElement('style');
      st.id = 'tod-chat-css';
      st.textContent = CHAT;
      host.shadowRoot.appendChild(st);
    }
    return true;
  }
  function early() {
    var host = document.querySelector('shopify-chat');
    if (!host) { return; }
    if (window.pageYOffset < 560 && designer()) { host.setAttribute('data-tod-early', ''); }
    else { host.removeAttribute('data-tod-early'); }
  }
  var n = 0;
  var slow = setInterval(function () {
    n += 1;
    chat(); early();
    if (n > 60) { clearInterval(slow); }
  }, 1000);
  window.addEventListener('scroll', early, { passive: true });

  /* 2 + 3. Text size and tap targets */
  function clear(bg) { return !bg || bg === 'transparent' || /rgba\(.*,\s*0\)$/.test(bg); }

  function tidy() {
    var i, e, s, r;
    var txt = document.querySelectorAll('.tod p, .tod li, .tod span, .tod label, .tod small');
    for (i = 0; i < txt.length; i++) {
      e = txt[i];
      if (e.classList.contains('tod-txt') || !e.offsetParent) { continue; }
      if (e.closest('header, nav, .hdr, .navdraw, .tod-mbar, .tod-sbar, .tfirst, svg')) { continue; }
      var own = '';
      for (var c = 0; c < e.childNodes.length; c++) {
        if (e.childNodes[c].nodeType === 3) { own += e.childNodes[c].nodeValue; }
      }
      own = own.trim();
      if (own.length < 18 || own.indexOf(' ') === -1) { continue; }
      s = getComputedStyle(e);
      if (s.textTransform === 'uppercase') { continue; }
      var fs = parseFloat(s.fontSize);
      if (fs >= 13.5 || fs < 9) { continue; }
      e.classList.add('tod-txt');
    }

    var taps = document.querySelectorAll('.tod a[href], .tod button');
    for (i = 0; i < taps.length; i++) {
      e = taps[i];
      if (e.classList.contains('tod-tap') || !e.offsetParent) { continue; }
      if (e.closest('header, nav, .hdr, .navdraw, .tod-mbar, .tod-sbar, .tfirst, .sp, svg')) { continue; }
      r = e.getBoundingClientRect();
      if (!r.height || r.height >= 40) { continue; }
      s = getComputedStyle(e);
      if (!clear(s.backgroundColor) || parseFloat(s.borderTopWidth) > 0 ||
          parseFloat(s.borderBottomWidth) > 1 || s.backgroundImage !== 'none') { continue; }
      if (s.position === 'absolute' || s.position === 'fixed') { continue; }
      e.style.setProperty('--tp', Math.ceil((44 - r.height) / 2) + 'px');
      e.classList.add('tod-tap');
      if (s.display === 'inline') { e.classList.add('tod-tap-i'); }
    }
  }

  var q = null;
  function soon() { if (q) { clearTimeout(q); } q = setTimeout(function () { q = null; try { tidy(); } catch (x) {} }, 350); }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', soon); } else { soon(); }
  window.addEventListener('load', soon);
  setTimeout(soon, 1500);
  document.addEventListener('click', soon, true);
})();
} catch (e) { setTimeout(function () { throw e; }); }

/* ---- snippets/tod-namefirst.liquid ---- */
try {
(function () {
  'use strict';
  if (!window.matchMedia || !matchMedia('(max-width: 767px)').matches) { return; }

  function $(s) { return document.querySelector(s); }
  function real() { return $('#cb-name') || $('#lines-cape input.ltext') || $('.tod input.ltext'); }
  function stage() { return $('.cb-stage') || $('.tod .stage') || $('.tod .cfg'); }
  function fire(el, type) { try { el.dispatchEvent(new Event(type, { bubbles: true })); } catch (e) {} }
  var SOLO = !!$('#cb-name');

  function go(y) {
    var y0 = window.pageYOffset;
    try { window.scrollTo({ top: y, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, y); }
    /* if smooth scrolling is off or stalls, finish the jump anyway */
    setTimeout(function () { if (Math.abs(window.pageYOffset - y0) < 4 && Math.abs(y - y0) > 4) { try { window.scrollTo({ top: y, behavior: 'instant' }); } catch (e) { window.scrollTo(0, y); } } }, 700);
  }

  /* 4. Name on the first screen */
  function first() {
    if ($('#tod-first')) { return true; }
    var r = real(), h1 = $('.tod h1');
    if (!r || !h1) { return false; }
    var at = h1, n = h1.nextElementSibling;
    while (n && n.tagName === 'P') { at = n; n = n.nextElementSibling; }

    var box = document.createElement('div');
    box.id = 'tod-first';
    box.className = 'tfirst';
    var max = r.maxLength > 0 ? r.maxLength : 30;
    box.innerHTML = '<label for="tod-first-in">' + (SOLO ? 'Try it — type your name or @handle'
        : 'Try it — type your salon name') + '</label>'
      + '<div class="tf-row"><input id="tod-first-in" type="text" autocomplete="off" autocapitalize="words"'
      + ' enterkeyhint="go" maxlength="' + max + '" placeholder="' + (SOLO ? 'Your name' : 'Your salon name') + '">'
      + '<button type="button">See it</button></div>';
    at.parentNode.insertBefore(box, at.nextSibling);

    var inp = box.querySelector('input'), btn = box.querySelector('button');
    inp.value = r.value || '';
    inp.addEventListener('input', function () {
      var t = real();
      if (!t) { return; }
      t.value = inp.value;
      fire(t, 'input');
    });
    function jump() {
      var t = real();
      if (t) { t.value = inp.value; fire(t, 'input'); fire(t, 'change'); }
      inp.blur();
      var s = stage() || t;
      if (s) { go(s.getBoundingClientRect().top + window.pageYOffset - 12); }
    }
    btn.addEventListener('click', jump);
    inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); jump(); } });
    document.addEventListener('input', function (e) {
      var t = real();
      if (t && e.target === t && document.activeElement !== inp) { inp.value = t.value; }
    }, true);
    return true;
  }

  /* 5. Buy bar on the single-cape designer — only if the designer has no bar of its own (#cb-bar) */
  function bar() {
    if (!SOLO || $('#tod-sbar') || $('#cb-bar') || document.body.classList.contains('tod-mbar-live')) { return; }
    var b = document.createElement('div');
    b.id = 'tod-sbar';
    b.className = 'tod-sbar';
    b.setAttribute('aria-hidden', 'true');
    b.innerHTML = '<div class="sb-p"><b></b><span>Free shipping on orders $99+</span></div><button type="button"></button>';
    document.body.appendChild(b);
    document.body.classList.add('tod-sbar-live');
    var price = b.querySelector('b'), btn = b.querySelector('button');

    function primary() {
      var a = $('#cb-add');
      if (a && a.offsetParent) { return a; }
      var nx = document.querySelectorAll('.tsx-next');
      for (var i = 0; i < nx.length; i++) { if (nx[i].offsetParent) { return nx[i]; } }
      return null;
    }
    function named() { var t = $('#cb-name'); return !!(t && t.value.trim()); }

    btn.addEventListener('click', function () {
      if (!named()) {
        var t = $('#cb-name');
        if (t) { go(t.getBoundingClientRect().top + window.pageYOffset - 320); setTimeout(function () { t.focus(); }, 450); }
        return;
      }
      var p = primary();
      if (p) { p.click(); }
    });

    var shown = false;
    function sync() {
      var t = $('#cb-total');
      price.textContent = t ? t.textContent.trim() : '';
      var p = primary();
      btn.textContent = !named() ? 'Type your name' : (p ? (p.textContent || '').trim() : 'Continue');
      var ae = document.activeElement;
      var typing = ae && (ae.tagName === 'INPUT' || ae.tagName === 'TEXTAREA') && ae.type !== 'checkbox';
      var off = true;
      if (p) { var r = p.getBoundingClientRect(); off = r.top > window.innerHeight - 60 || r.bottom < 0; }
      var want = window.pageYOffset > 260 && off && !typing;
      if (want !== shown) {
        shown = want;
        b.classList.toggle('on', want);
        b.setAttribute('aria-hidden', want ? 'false' : 'true');
      }
    }
    var tick = setInterval(sync, 400);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { clearInterval(tick); tick = null; } else if (!tick) { tick = setInterval(sync, 400); }
    });
    window.addEventListener('scroll', sync, { passive: true });
    sync();
  }

  function pass() { try { first(); } catch (e) {} try { bar(); } catch (e) {} }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', pass); } else { pass(); }
  setTimeout(pass, 800);
  setTimeout(pass, 2000);
})();
} catch (e) { setTimeout(function () { throw e; }); }
